<ion-content>
  <ion-card class="survey-container">
    <div *ngIf="isValidSurvey && !isSubmitted">
      <h2>{{ title }}</h2>

      <!-- NPS Score Selection -->
      <div class="score-section" *ngIf="surveyType === 'nps'">
        <h3>How likely are you to recommend us?</h3>
        <div class="score-options">
          <button
            *ngFor="let score of npsScores"
            [class.selected]="selectedScore === score"
            (click)="selectedScore = score"
            class="score-button"
          >
            {{ score }}
          </button>
        </div>
        <div class="score-labels">
          <span>Not likely</span>
          <span>Very likely</span>
        </div>
      </div>

      <!-- Alternative CSAT Emoji Selection -->
      <div class="score-section" *ngIf="surveyType === 'csat'">
        <h3>How satisfied are you with our service?</h3>
        <div class="emoji-options">
          <button
            *ngFor="let emoji of csatEmojis; let i = index"
            [class.selected]="selectedScore === i + 1"
            (click)="selectedScore = i + 1"
            class="emoji-button"
          >
            {{ emoji }}
          </button>
        </div>
      </div>

      <!-- Add an email input if none provided -->
      <div class="email-section" *ngIf="!userId">
        <h3>Please enter your email</h3>
        <ion-input type="email" placeholder="Email" [(ngModel)]="email" class="input-field"></ion-input>
      </div>

      <!-- Feedback Text Area -->
      <div class="feedback-section">
        <h3>Additional comments</h3>
        <ion-textarea
          class="input-field"
          [(ngModel)]="comment"
          placeholder="Please share any additional feedback..."
          rows="4"
        >
        </ion-textarea>
      </div>

      <ion-button class="no-margin" (click)="submitSurvey()" size="block" [disabled]="!selectedScore || isLoading">
        Submit Feedback
      </ion-button>
    </div>
    <div *ngIf="isSubmitted && isValidSurvey" style="text-align: center">
      <ion-icon
        name="checkmark-circle-outline"
        style="color: var(--ion-color-success); font-size: 5.5rem; margin: 2rem 0"
      ></ion-icon>
      <h2>Thank you for your feedback!</h2>
    </div>
    <div *ngIf="!isValidSurvey" style="text-align: center">
      <ion-icon name="shapes-outline" style="opacity: 0.5; font-size: 5.5rem; margin: 2rem 0"></ion-icon>
      <h2>No survey found</h2>
      <p>
        <a href="https://unthread.io">Go to Unthread home</a>
      </p>
    </div>
  </ion-card>
  <div style="text-align: center; width: 100%; margin-top: 5px">
    <a
      href="https://www.unthread.io?utm_source=survey_footer"
      rel="noreferrer noopener nofollow"
      target="_blank"
      class="branding--link"
      ><img alt="Unthread" src="{{ environment.assetsBaseUrl + '/icons/icon.svg' }}" class="branding--image" />
      <span> Powered by Unthread </span>
    </a>
  </div>
</ion-content>
